export enum HeaderBiddingPlatforms {
    PREBID = "prebid",
    AMAZON_TAM = "amazon_tam",
}
